/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusFunktionMiniListResponseDto } from '../../models/lexplus-funktion-mini-list-response-dto';

export interface FunktionenControllerFindAllPaginatedV1$Params {
  onlyUnassigned?: boolean;

/**
 * Page number to retrieve. If you provide invalid value the default page number will applied
 *
 * **Example:** 1
 *
 *
 * **Default Value:** 1
 */
  page?: number;

/**
 * Number of records per page.
 *
 *
 * **Example:** 20
 *
 *
 *
 * **Default Value:** 25
 *
 *
 *
 * **Max Value:** 100
 *
 *
 * If provided value is greater than max value, max value will be applied.
 */
  limit?: number;

/**
 * Filter by name query param.
 *
 * **Format:** filter.name={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.name=$eq:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $and
 *
 * - $or
 */
  'filter.name'?: Array<string>;

/**
 * Filter by shortcutID query param.
 *
 * **Format:** filter.shortcutID={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.shortcutID=$eq:John Doe&filter.shortcutID=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $null
 *
 * - $and
 *
 * - $or
 */
  'filter.shortcutID'?: Array<string>;

/**
 * Filter by standortID query param.
 *
 * **Format:** filter.standortID={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.standortID=$eq:John Doe&filter.standortID=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $null
 *
 * - $and
 *
 * - $or
 */
  'filter.standortID'?: Array<string>;

/**
 * Parameter to sort by.
 * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
 *
 * **Format:** {fieldName}:{DIRECTION}
 *
 *
 * **Example:** sortBy=shortcutID:DESC&sortBy=name:DESC
 *
 *
 * **Default Value:** name:ASC
 *
 * **Available Fields**
 * - shortcutID
 *
 * - name
 *
 * - standortID
 *
 * - uebersetzung
 */
  sortBy?: Array<'shortcutID:ASC' | 'shortcutID:DESC' | 'name:ASC' | 'name:DESC' | 'standortID:ASC' | 'standortID:DESC' | 'uebersetzung:ASC' | 'uebersetzung:DESC'>;

/**
 * Search term to filter result values
 *
 * **Example:** John
 *
 *
 * **Default Value:** No default value
 */
  search?: string;

/**
 * List of fields to search by term to filter result values
 *
 * **Example:** name,uebersetzung
 *
 *
 * **Default Value:** By default all fields mentioned below will be used to search by term
 *
 * **Available Fields**
 * - name
 *
 * - uebersetzung
 */
  searchBy?: Array<string>;

/**
 * List of fields to select.
 *
 * **Example:** shortcutID,uebersetzung,name,standort.standortID,standort.name
 *
 *
 * **Default Value:** By default all fields returns. If you want to select only some fields, provide them in query param
 */
  select?: string;
}

export function funktionenControllerFindAllPaginatedV1(http: HttpClient, rootUrl: string, params?: FunktionenControllerFindAllPaginatedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusFunktionMiniListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, funktionenControllerFindAllPaginatedV1.PATH, 'get');
  if (params) {
    rb.query('onlyUnassigned', params.onlyUnassigned, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.name', params['filter.name'], {});
    rb.query('filter.shortcutID', params['filter.shortcutID'], {});
    rb.query('filter.standortID', params['filter.standortID'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
    rb.query('select', params.select, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusFunktionMiniListResponseDto>;
    })
  );
}

funktionenControllerFindAllPaginatedV1.PATH = '/v1/funktionen/paginated';
